import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * LegalFooter - Global footer med juridiske lenker (Dark Theme)
 * Brukes på alle sider i appen
 */
function LegalFooter({ className = '' }) {
  const { t, i18n } = useTranslation();
  const isNorwegian = i18n.language === 'nb' || i18n.language === 'no';
  
  return (
    <footer className={`border-t border-slate-800 bg-slate-950 ${className}`} data-testid="legal-footer">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo og copyright */}
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-500">© 2025 Valoria Solutions AS</span>
          </div>

          {/* Juridiske lenker */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/terms" 
              className="text-slate-400 hover:text-cyan-400 transition-colors"
              data-testid="footer-terms-link"
            >
              {isNorwegian ? 'Vilkår' : 'Terms'}
            </Link>
            <Link 
              to="/privacy" 
              className="text-slate-400 hover:text-cyan-400 transition-colors"
              data-testid="footer-privacy-link"
            >
              {isNorwegian ? 'Personvern' : 'Privacy'}
            </Link>
            <Link 
              to="/disclaimer" 
              className="text-slate-400 hover:text-cyan-400 transition-colors"
              data-testid="footer-disclaimer-link"
            >
              {isNorwegian ? 'Ansvarsfraskrivelse' : 'Disclaimer'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

/**
 * LegalFooterCompact - Kompakt versjon for innloggede sider (Dark Theme)
 */
export function LegalFooterCompact() {
  const { i18n } = useTranslation();
  const isNorwegian = i18n.language === 'nb' || i18n.language === 'no';
  
  return (
    <div className="text-center py-4 text-xs text-slate-500" data-testid="legal-footer-compact">
      <div className="flex items-center justify-center gap-4">
        <Link to="/terms" className="hover:text-cyan-400 transition-colors">
          {isNorwegian ? 'Vilkår' : 'Terms'}
        </Link>
        <span className="text-slate-700">•</span>
        <Link to="/privacy" className="hover:text-cyan-400 transition-colors">
          {isNorwegian ? 'Personvern' : 'Privacy'}
        </Link>
        <span className="text-slate-700">•</span>
        <span>© 2025 Valoria Solutions AS</span>
      </div>
    </div>
  );
}

export default LegalFooter;
